// routes
import { paths } from 'src/routes/paths';

export const FOOTER_LINKS = [
  {
    headline: 'Explore',
    children: [
      { name: 'Contact', href: paths.supportPath.contact },
      // { name: 'Security', href: paths.securityPage },
      { name: 'FAQs', href: paths.supportPath.faqs },
      { name: 'View Documentation', href: paths.docs.overview },
      { name: 'Trust', href: paths.trust},
    ],
  },
  {
    headline: 'ST Workbench',
    children: [
      { name: 'Login', href: paths.auth.firebase.login },
      { name: 'Register for Beta User', href: paths.auth.firebase.register },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Legal Disclosure', href: paths.legal.legalDisclosure },
      { name: 'Terms of Service', href: paths.legal.termsOfService },
      { name: 'Privacy Policy', href: paths.legal.privacyPolicy },
      { name: 'Cookie Policy', href: paths.legal.cookiePolicy },
      { name: 'Data Processing Agreement', href: paths.legal.dataProcessingAgreement },
      { name: 'EAA Contractual Clauses', href: paths.legal.eeaStandardContactualClauses },
      { name: 'Disclaimer', href: paths.legal.disclaimer },
    ],
  },
];